import gql from "graphql-tag";

export default gql`
  query ListingUpgradeServiceQuery(
    $collectionId: Int
    $targetCurrency: String
  ) {
    upgradeService(
      collectionId: $collectionId
      targetCurrency: $targetCurrency
    ) {
      displayPrice
      scheduleType
      type
      subType
    }
  }
`;
